/* UserChangeEmail.js */

import React, { useCallback, useEffect, useState } from 'react';
import { Label, FormGroup, Row, Col } from 'reactstrap';
import WAM from '../../services/WAM';
import { useAuth } from '../../context/auth/AuthContext';
import Strings from '../../translations/Translations';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import Button1 from '../buttons/Button1';

export default function UserChangeEmail () {
  const { authenticated, toggleLoading } = useAuth();
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({ name: '', biography: '', website: '' });
  const { register, formState: { errors }, handleSubmit, getValues, setValue } = useForm();

  const onSubmit = useCallback(async ({ new_email }) => {
    let enabledToRequest = false;
    if (new_email !== userData.email) {
      enabledToRequest = true;
    }

    if (enabledToRequest) {
      const requestData = {};
      requestData.username = authenticated.un;
      requestData.al = authenticated.al;
      requestData.new_email = new_email;

      setLoading(true);
      try {
        const response = await WAM.changeUserEmail(requestData);
  
        if (response.result === 'success') {
          toast.success(Strings('please_verify_your_new_email_to_confirm_change'));
          setValue('new_email', '');
          setValue('confirm_new_email', '');
        } else {
          const message = (response && response.error) ? response.error : Strings('error_on_update');
          toast.error(message);
        }
      } catch (err) {
        toast.error(Strings('general_error'));
      }
      setLoading(false);
    }
  }, [authenticated, setLoading, userData, setValue]);

  const getUserData = useCallback(async () => {
    const username = authenticated.un;
    const al = authenticated.al;
    toggleLoading(true);

    try {
      const response = await WAM.getUserProfile({username, al});
      if (response && response.result === 'success') {
        const data = WAM.listToJson(response.list);
        const userDataToSet = {};
        userDataToSet.name = (data.obj2) ? data.obj2 : '';
        userDataToSet.biography = (data.obj4) ? data.obj4 : '';
        userDataToSet.website = (data.obj6) ? data.obj6 : '';
        userDataToSet.email = (data.obj7) ? data.obj7 : '';
        setUserData(userDataToSet);
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_request');
        toast.error(message);
      }
    } catch (err) {
      toast.error(Strings('general_error'));
    }

    toggleLoading(false);
  }, [authenticated, toggleLoading, setUserData]);

  useEffect(() => { getUserData(); }, [getUserData]);

  return (
    <Row>
      <Col sm={12} className='mb-1'>
        <h2 className='h5'>
          {Strings('change_email')}
        </h2>
      </Col>

      <Col sm={12} className='mb-1'>
        <FormGroup>
          <Label className='pb-label-1'>{Strings('new_email')}</Label>
          <input
            type='email'
            className='form-control shadow pb-input-1'
            name='new_email'
            {...register('new_email', { required: true })}
          />
          {errors && errors.new_email && errors.new_email.type === 'required' && (
            <p role='alert' className='text-danger txt-small-1'>{Strings('new_email_is_required')}</p>
          )}
        </FormGroup>
      </Col>
      <Col sm={12} className='mb-1'>
        <FormGroup>
          <Label className='pb-label-1'>{Strings('confirm_new_email')}</Label>
          <input
            type='email'
            className='form-control shadow pb-input-1'
            name='confirm_new_email'
            {...register('confirm_new_email', {
              required: true,
              validate: (value) => {
                const new_email = getValues('new_email');
                return new_email === value;
              }
            })}
          />
          {errors && errors.confirm_new_email && errors.confirm_new_email.type === 'required' && (
            <p role='alert' className='text-danger txt-small-1'>{Strings('confirm_new_email_is_required')}</p>
          )}
          {errors && errors.confirm_new_email && errors.confirm_new_email.type === 'validate' && (
            <p role='alert' className='text-danger txt-small-1'>{Strings('emails_must_match')}</p>
          )}
        </FormGroup>
      </Col>
      <Col sm={12}>
        <Button1
          size='lg'
          className='pb-btn-1'
          onClick={handleSubmit(onSubmit)}
          loading={loading}
          disabled={loading}
        >
          {Strings('change')}
        </Button1>
      </Col>

    </Row>
  );
}
